import React, { createContext, useState } from "react";

const DespesasReembolsaveisContext = createContext();

const DespesasReembolsaveisContextProvider = ({ children }) => {
  const [id, setId] = useState(null);
  const [description, setDescription] = useState("");
  const [complement, setComplement] = useState("");
  const [companies, setCompanies] = useState([]);
  const [active, setActive] = useState(true);
  const [loading, setLoading] = useState(false);
  const [errorsSubmit, setErrorsSubmit] = useState({});
  const [dataTableReload, setDataTableReload] = useState(false);
  const [service, setService] = useState(null);
  const [serviceList, setServiceList] = useState([]);

  return (
    <DespesasReembolsaveisContext.Provider
      value={{
        description,
        setDescription,
        complement,
        setComplement,
        active,
        setActive,
        companies,
        setCompanies,
        id,
        setId,
        loading,
        setLoading,
        errorsSubmit,
        setErrorsSubmit,
        dataTableReload,
        setDataTableReload,
        service,
        setService,
        serviceList,
        setServiceList,
      }}
    >
      {children}
    </DespesasReembolsaveisContext.Provider>
  );
};

export { DespesasReembolsaveisContext, DespesasReembolsaveisContextProvider };
